import React, { createContext, useContext, useState, useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { setLoaderStore } from "../../axios"; // ✅ connect immediately

// ---------------- Context Setup ----------------
const LoaderContext = createContext();

export const LoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  // ✅ Register loader with Axios immediately when provider mounts
  useEffect(() => {
    setLoaderStore({ 
      setLoading: (isLoading, apiUrl = '') => {
        // DON'T show loader for transport_list API, show for all others
        if (!apiUrl.includes('/temple/transport_list')) {
          setLoading(isLoading);
        }
        // For transport API, do nothing (no loader)
      }
    });
  }, []);

  return (
    <LoaderContext.Provider value={{ loading, setLoading }}>
      {children}
      {loading && <MyCustomLoader />}
    </LoaderContext.Provider>
  );
};

export const useLoader = () => useContext(LoaderContext);

// ---------------- Loader Component ----------------
const MyCustomLoader = () => {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "rgba(0, 0, 0, 0.3)",
        zIndex: 2000,
      }}
    >
      {/* Loader */}
      <div
        style={{
          width: "50px",
          aspectRatio: "1",
          borderRadius: "50%",
          background:
            "radial-gradient(farthest-side,#ffa516 94%,#0000) top/8px 8px no-repeat, conic-gradient(#0000 30%,#ffa516)",
          WebkitMask:
            "radial-gradient(farthest-side,#0000 calc(100% - 8px),#000 0)",
          animation: "l13 1s infinite linear",
        }}
      />
      {/* Inline keyframes */}
      <style>
        {`
          @keyframes l13 {
            100% { transform: rotate(1turn) }
          }
        `}
      </style>
    </Box>
  );
};

export default MyCustomLoader;